import FeaturePromotionDataTransformerBlock from '@activebrands/core-web/libs/storyblok/content/CmsDataTransformerBlock/FeaturePromotionDataTransformerBlock';
import { ModuleSection } from '@activebrands/core-web/components/modules/ModuleSection';
import { useStyletron } from '@activebrands/core-web/libs/styletron';

interface FeaturePromotionModuleProps {
    isGrid?: boolean;
}

const FeaturePromotionModule = ({ isGrid = false, ...rest }: FeaturePromotionModuleProps) => {
    const [css] = useStyletron();

    return (
        <ModuleSection $isGrid={isGrid}>
            <div className={css({ marginLeft: 'auto', marginRight: 'auto' })}>
                <FeaturePromotionDataTransformerBlock {...rest} />
            </div>
        </ModuleSection>
    );
};

export default FeaturePromotionModule;
